<template>
  <div>
    <div class="scene" :key="index" v-for="(page, index) in pages">
      <template v-if="index % 2">
        <div class="left left2">
          <p class="label" v-html="page.label" />
          <p class="detail" v-html="page.detail" />
        </div>
        <div class="right">
          <img class="topic" :src="page.topic" />
        </div>
      </template>
      <template v-else>
        <div class="right">
          <img class="topic" :src="page.topic" />
        </div>
        <div class="left">
          <p class="label" v-html="page.label" />
          <p class="detail" v-html="page.detail" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scene',
  data() {
    return {
      pages: [
        { prop: 'security', image: 'scene1.png', label: this.$t('Home.scene.static.security.label'), detail: this.$t('Home.scene.static.security.detail') },
        { prop: 'privacy', image: 'scene2.png', label: this.$t('Home.scene.static.privacy.label'), detail: this.$t('Home.scene.static.privacy.detail') },
        { prop: 'extension', image: 'scene3.png', label: this.$t('Home.scene.static.extension.label'), detail: this.$t('Home.scene.static.extension.detail') }
      ]
    }
  },
  created() {
    this.pages.forEach(obj => {
      obj.topic = require('@/assets/' + obj.image)
    })
  }
}
</script>

<style scoped>
.scene {
  width: 100%;
  height: 50rem;

  display: flex;
  flex-direction: row;
}

.scene .left {
  width: 40%;
  height: 100%;
  padding: 10rem 0;
}
.scene .left2 {
  padding-left: 20rem;
}
.scene .right {
  width: 60%;
  height: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.left .label {
  font-size: 3.25rem;
  line-height: 4rem;
  padding-bottom: 1rem;
}
.left .detail {
  font-size: 1.6rem;
  line-height: 2.2rem;
}

.right .topic {
  /* width: 85%; */
  height: 100%;
}
</style>
